export default function SidebarService(
    $rootScope,
    authService,
    userService
) {
    'ngInject';

    Object.assign(this, {
        isFlightSearchAvailable,
        isHotelSearchAvailable,
        isCarSearchAvailable,
        isEurostarSearchAvailable,
        isRailSearchAvailable,
        isFlightSearchAvailableTwo,
    });

    function isFlightSearchAvailable() {
        const availableServices = authService.getAvailableServicesFromSessionStorage();
        return $rootScope.readOnlyMode || (availableServices && availableServices.IsFlightSearchAvailable);
    }

    function isFlightSearchAvailableTwo() {
        const availableServices = authService.getAvailableServicesFromSessionStorage();
        return $rootScope.readOnlyMode || (availableServices && availableServices.IsFlightSearchAvailable);
    }

    function isHotelSearchAvailable() {
        const availableServices = authService.getAvailableServicesFromSessionStorage();
        return $rootScope.readOnlyMode || (availableServices && availableServices.IsHotelSearchAvailable);
    }

    function isCarSearchAvailable() {
        const availableServices = authService.getAvailableServicesFromSessionStorage();
        return $rootScope.readOnlyMode || (availableServices && availableServices.IsCarSearchAvailable);
    }

    function isEurostarSearchAvailable() {
        const availableServices = authService.getAvailableServicesFromSessionStorage();
        return (userService.isUKRegion() && availableServices && availableServices.IsEurostarSearchAvailable)
                || $rootScope.readOnlyMode;
    }

    function isRailSearchAvailable() {
        const availableServices = authService.getAvailableServicesFromSessionStorage();
        return availableServices && availableServices.IsRailSearchAvailable;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/main/sidebar/sidebar-service.js